export enum UserRole {
  ADVISOR = 'ADVISOR',
  SUPER_ADVISOR = 'SUPER_ADVISOR',
  ADMIN = 'ADMIN',
  UNDERWRITER = 'UNDERWRITER',
  CASE_MANAGER = 'CASE_MANAGER',
}
